import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import useEvent from 'rc-util/es/hooks/useEvent';
import * as React from 'react';
import { unstable_batchedUpdates } from 'react-dom';
import channelUpdate from 'rc-overflow/es/hooks/channelUpdate';

/**
 * Patched copy of rc-overflow/es/hooks/useEffectState.js
 * Skips setState after unmount (fixes antd Select mode="tags" memory leak warning).
 */
export function useBatcher() {
    var updateFuncRef = React.useRef(null);

    var notifyEffectUpdate = function notifyEffectUpdate(callback) {
        if (!updateFuncRef.current) {
            updateFuncRef.current = [];
            channelUpdate(function () {
                unstable_batchedUpdates(function () {
                    updateFuncRef.current.forEach(function (fn) {
                        fn();
                    });
                    updateFuncRef.current = null;
                });
            });
        }
        updateFuncRef.current.push(callback);
    };
    return notifyEffectUpdate;
}

export default function useEffectState(notifyEffectUpdate, defaultValue) {
    var isMountedRef = React.useRef(true);

    React.useEffect(function () {
        isMountedRef.current = true;
        return function () {
            isMountedRef.current = false;
        };
    }, []);

    var _React$useState = React.useState(defaultValue),
        _React$useState2 = _slicedToArray(_React$useState, 2),
        stateValue = _React$useState2[0],
        setStateValue = _React$useState2[1];

    var setEffectVal = useEvent(function (nextValue) {
        notifyEffectUpdate(function () {
            if (isMountedRef.current) {
                setStateValue(nextValue);
            }
        });
    });
    return [stateValue, setEffectVal];
}
